var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"image",staticClass:"img-fluid",attrs:{"height":_vm.height,"width":_vm.width,"src":'/media/' + _vm.sizeUrl + '?' + _vm.date}})}
var staticRenderFns = []

export { render, staticRenderFns }